import WelcomePageView from './WelcomePage.view';

const WelcomePage = () => {
  return <WelcomePageView />;
};
export default WelcomePage;
